import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import { BoxProps } from '@mantine/core'
import { useListState } from '@mantine/hooks'

import { useRouterExtend } from 'hooks/useRouterExtend'
import {
  ScheduleEventCard,
  SpotlightScheduleEventSession,
} from 'interfaces/types'

import {
  DATE_FORMAT_API,
  ScheduleEventContext,
  ScheduleEventStatus,
} from './context'
import { EventList } from './eventList'
import { HighlightEvent } from './highlightEvent'
import { formatCard } from './utils'
import orderBy from 'lodash/orderBy'
import dayjs from 'dayjs'
import LeadgenSection from './leadgenSection'

type Props = {
  applyH1?: boolean
} & SpotlightScheduleEventSession &
  BoxProps

export const ScheduleEvent = (props: Props) => {
  const { locale } = useRouterExtend()
  const { listEvent: listEventProps, wrapperProps } = props
  const sortList = useMemo(() => {
    const convertDate = listEventProps.map((i) => ({
      ...i,
      timestamp: dayjs(i.startDate, DATE_FORMAT_API).unix(),
    }))
    return orderBy(convertDate, ['timestamp'], ['asc'])
  }, [listEventProps])
  const [listEvent, handlers] = useListState(formatCard(sortList, locale))
  const [campaign, setCampaign] = useState<any>()
  const [
    highlightEvent,
    setHighlightEvent,
  ] = useState<ScheduleEventCard | null>(null)
  const leadModalRef = useRef<any>()

  const openLeadModal = useCallback(() => {
    leadModalRef?.current?.openModal()
  }, [])

  const changeToLivedEvent = useCallback(
    (item: ScheduleEventCard) => {
      const findIndex = listEventProps.findIndex((i) => i.id === item.id)
      if (findIndex > -1) {
        handlers.setItemProp(findIndex, 'state', ScheduleEventStatus.LIVED)
      }
    },
    [listEvent],
  )

  const changeToLiveEvent = useCallback(
    (item: ScheduleEventCard) => {
      const findIndex = listEventProps.findIndex((i) => i.id === item.id)
      if (findIndex > -1) {
        handlers.setItemProp(findIndex, 'state', ScheduleEventStatus.LIVE)
      }
    },
    [listEvent],
  )

  useEffect(() => {
    setTimeout(() => openLeadModal(), 1000)
  }, [])

  useEffect(() => {
    handlers.filter((i) => i.id !== highlightEvent?.id)
    setCampaign(null)
  }, [highlightEvent])

  return (
    <ScheduleEventContext.Provider
      value={{
        ...props,
        listEvent,
        wrapperProps,
        changeToLivedEvent,
        changeToLiveEvent,
        openLeadModal,
        campaign,
        setCampaign,
        highlightEvent,
        setHighlightEvent,
      }}
    >
      <HighlightEvent />
      <EventList />
      {campaign && highlightEvent && (
        <LeadgenSection
          ref={leadModalRef}
          event={highlightEvent}
          campaign={campaign}
        />
      )}
    </ScheduleEventContext.Provider>
  )
}
